import { type ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useAuthStore } from '../store/auth.store';

export function PrivateRoute({ children }: { children: ReactElement }) {
  const isAuth = useAuthStore((s) => s.isAuthenticated());
  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
